<kendo-icon name="loading" [themeColor]="themeColor" [hidden]="!loading" [size]="size"></kendo-icon>
